import { render, staticRenderFns } from "./GlobalSearchToggle.vue?vue&type=template&id=278a3c4a&scoped=true&"
import script from "./GlobalSearchToggle.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchToggle.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSearchToggle.vue?vue&type=style&index=0&id=278a3c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a3c4a",
  null
  
)

export default component.exports